import { Icon } from '@iconify/react';
import { useEffect, useState } from 'react';
import { showDeleteConfirmBox } from '../../../../../components/DeleteConfirmBox';
import { getCommaSeparatedNumber } from '../../../../../utils/common';
import { getDepartments } from '../apis/department-apis';
import { DiscipleType } from '../types/disciple';
import styles from './AdminYCMS.module.css';

type Department = {
  id: number;
  name: string;
};

type Props = {
  types: DiscipleType[];
  onChange: (
    {
      target: { name, value },
    },
    idx: number,
  ) => void;
  onEdit: (type: DiscipleType) => void;
  onDelete: (id: number) => void;
  highlightedId?: number | null;
};

export const DiscipleTypeList = ({ types, onChange, onEdit, onDelete, highlightedId }: Props) => {
  const [departments, setDepartments] = useState<Department[]>([]);

  useEffect(() => {
    getDepartments().then(setDepartments);
  }, []);

  if (!types || types.length === 0) {
    return null;
  }

  return (
    <>
      {types.map((item, idx) => {
        const isHighlighted = highlightedId === item.id;
        return (
          <tr
            key={idx}
            id={String(idx)}
            className={isHighlighted ? styles.highlightedRow : ''}
          >
          <td className={styles.td_disciple}>{idx + 1}</td>
          <td className={styles.td_disciple}>
            <select className={styles.textInput} name="departmentId" value={item.departmentId ?? 0} onChange={(e) => onChange(e, idx)}>
              <option value={0}>선택</option>
              {departments.map((dept) => (
                <option key={dept.id} value={dept.id}>
                  {dept.name}
                </option>
              ))}
            </select>
          </td>
          <td className={styles.td_disciple}>
            <input type="text" className={styles.textInput} name="displayName" value={item.displayName || ''} onChange={(e) => onChange(e, idx)} />
          </td>
          <td className={styles.td_disciple}>
            <input type="text" className={styles.textInput} name="description" value={item.description || ''} onChange={(e) => onChange(e, idx)} />
          </td>
          <td className={styles.td_disciple}>
            <input
              type="text"
              className={styles.textInput}
              name="target"
              style={{ textAlign: 'right' }}
              value={item.target ? getCommaSeparatedNumber(item.target) : ''}
              onChange={(e) => {
                let result = e.target.value;
                result = result.replace(/^0/g, ''); // 첫 글자가 0이면 제거
                result = result.replace(/[^0-9]/g, ''); // 숫자만 남김
                onChange({ target: { name: 'target', value: result } }, idx);
              }}
            />
          </td>
          <td className={styles.td_disciple}>
            <div className={styles.tooltipWrapper} style={{ position: 'relative', width: '100%' }}>
              <input
                type="text"
                className={styles.textInput}
                value={item.targetPercentage !== undefined && typeof item.targetPercentage === 'number' ? `${item.targetPercentage.toFixed(2)}%` : ''}
                readOnly
                style={{ backgroundColor: '#f5f5f5', cursor: 'help', textAlign: 'right' }}
              />
            </div>
          </td>
          <td className={styles.td_disciple}>
            <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center' }}>
              <button className={styles.iconButton} onClick={() => onEdit(item)} title="수정">
                <Icon icon="mdi:pencil" width={18} height={18} />
              </button>
              <button className={styles.iconButton} onClick={() => showDeleteConfirmBox(() => onDelete(item.id))} title="삭제">
                <Icon icon="mdi:delete" width={18} height={18} />
              </button>
            </div>
          </td>
        </tr>
        );
      })}
    </>
  );
};
